<template>
	<div class="modal-insert-dialog">
		<div class="insert-inner">
			<div class="insert-tab">
				<span :class="{active:isActive}"><i class="el-icon-chat-dot-square"></i><em>Dialog</em></span>
				<span @click="optionFn"><i class="el-icon-chat-line-square"></i><em>Options</em></span>
				<span @click="uploadImage"><i class="el-icon-picture-outline"></i><em>Picture</em></span>
			</div>
			<div class="insert-roles">
				<div class="insert-roles-box">
					<ul>
						<li v-if="protagonist_list.length > 0" v-for="(item,index) in protagonist_list" :key="item.id" :class="{'active':checkId === item.id}" @click="activeRoleFn(item)">
							<span>
								<i v-if="item.sex === 0"><img :src="require('../../assets/roles/bg_avatar_female_'+ item.icon +'.png')" /></i>
								<i v-else-if="item.sex === 1"><img :src="require('../../assets/roles/bg_avatar_male_'+ item.icon +'.png')" /></i>
								<em>{{item.rolename}}</em>
							</span>
						</li> 
						<li :class="{'active':checkId === narration_role.id}" :key="narration_role.id" @click="activeRoleFn(narration_role)">
							<span>
								<i><img :src="require('../../assets/roles/'+ narration_role.icon +'.png')" /></i>
								<em>{{narration_role.rolename}}</em>
							</span>
						</li> 
						<li v-if="suportingRole_list.length > 0" v-for="(item,index) in suportingRole_list" :key="item.id" :class="{'active':checkId === item.id}" @click="activeRoleFn(item)">
							<span>
								<i v-if="item.sex === 0"><img :src="require('../../assets/roles/bg_avatar_female_'+ item.icon +'.png')" /></i>
								<i v-else-if="item.sex === 1"><img :src="require('../../assets/roles/bg_avatar_male_'+ item.icon +'.png')" /></i>
								<em>{{item.rolename}}</em>
							</span>
						</li>
					</ul>
				</div>
			</div>
		</div>
		<el-row class="checked-btn"><el-button @click="saveDialog" type="primary" icon="el-icon-check" circle></el-button></el-row>
	</div>
</template>

<script>
	import axios from 'axios'
	import { mapState, mapActions, mapMutations} from 'vuex'
	export default {
		data() {
			return {
				isActive: true,
				axiosData: {
					"key": '',
					"Content-Type": 'image/jpeg',
					"acl": '',
					"X-Amz-Credential": '',
					"X-Amz-Algorithm": '',
					"X-Amz-Date": '',
					"X-Amz-Signature": '',
					"Policy": '',
				},
				checkId: 0
			}
		},
		created() {
			this.resetCheckId()
		},
		computed: {
			newRoleList() {
				return this.$store.state.roles.newRoleList
			},
			protagonist_list() {
				const protagonist_list = this.newRoleList.filter(item => {	
					return item.main === 1
				})
				return protagonist_list
			},
			suportingRole_list() {
				const suportingRole_list = this.newRoleList.filter(item => {
					return item.main === 0 && item.id !== 0
				})
				return suportingRole_list
			},
			narration_role() {
				// const narration_role = this.newRoleList.find(item => {
				// 	return item.id === 0
				// })
				// return narration_role
				return this.$store.state.dialog.narration[0]
			},
			insertDialog() {
				return this.$store.state.dialog.insertDialog
			}
		},
		methods: {  
			resetCheckId() {
				this.checkId = this.insertDialog.baseRole.role
			},
			saveDialog() {
				this.$store.dispatch('dialog/modalSaveDialogFn')
			},
			optionFn() {
				this.$store.dispatch('dialog/addOptionDialogFn','modal')
			},
			activeRoleFn(data) {
				this.checkId = data.id
				// 只有在触发了切换角色后才能获取到data 
				this.$store.commit('dialog/checkModalRoles', data)
			},
			uploadImage() {
				this.$store.commit('dialog/closeModalFn')
				axios({
					method: 'GET',
					url: `${this.$baseUrl}/h5/getBookUploadToken`,
					timeout: 2000,
					withCredentials: true,
					params: {
						book_id: this.$route.query.book_id
					}
				}).then((data) => {
					this.axiosData["key"] = data.data['file_name']
					this.axiosData["action"] = data.data['action']
					this.axiosData["acl"] = data.data['acl']
					this.axiosData["X-Amz-Credential"] = data.data["X-Amz-Credential"]
					this.axiosData["X-Amz-Algorithm"] = data.data["X-Amz-Algorithm"]
					this.axiosData["X-Amz-Date"] =  data.data["X-Amz-Date"]
					this.axiosData["X-Amz-Signature"] =  data.data["X-Amz-Signature"]
					this.axiosData["Policy"] =  data.data['Policy']
					const ImgData = Object.assign({},this.insertDialog)
					this.$store.dispatch('dialog/uploadImgDataFn',{axiosData:this.axiosData, ImgData:ImgData, uploadType: 'modalImg'})
				});
			}
		}
	}
</script>

<style lang="scss">
	.modal-insert-dialog {
		.insert-inner {
			display: flex;
		}
		.insert-tab {
			font-size: 12px;
			padding-right: 10px;
			span {
				display: flex;
				flex-flow: column;
				text-align: center;
				cursor: pointer;
				padding: 0 0 15px 0;
				color: #7c7b82;
				i {
					font-size: 26px;
					padding-bottom: 4px;
				}
				&.active,&:hover {
					color: #fa4863;
				}
			}
		}
		.el-divider--horizontal {
			margin: 20px 0;
		}
		.checked-btn {
			margin: 20px 0 0;
			display: flex;
			justify-content: center;    
		}
		.el-button.is-circle {
			padding: 6px;
			.el-icon-check {
				font-size: 20px
			}
		}
		.insert-roles-box {
			padding: 0;
			padding-left: 10px;
			border-left: 1px dashed #cdcdcd;
			min-height: 170px;
			li {
				display: inline-block;
				font-size: 10px;
				text-align: center;
				width: 56px;
				margin-bottom: 10px;
				padding: 0 2px;
				&.create {
					i {
						border-style: dashed;
					}
				}
				&.r-left {
					float: left
				}
				&.r-right {
					float: right
				}
				&.active,&:hover {
					i {
						background: #ffeaec;
					}
		
					em {
						color: #fa4863;
					}
				}
		
				&:hover {
					cursor: pointer;
				}
		
				i {
					width: 35px;
					height: 35px;
					margin-bottom: 2px;
					line-height: 51px;
					font-size: 26px;
					border-radius: 50%;
					text-align: center;
					background: #f7f7f7;
					color: #fa4863;
					display: inline-block;
					overflow: hidden;
		
					img {
						height: 35px;
					}
				}
		
				em {
					display: inline-block;
					width: 100%;
					height: 20px;
					overflow: hidden;
				}
			}
		}
	}
</style>
